import { setDefaultOptions } from 'date-fns';
import { da } from 'date-fns/locale/da';
import moment from 'moment';
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import * as langs from '@debbie/common/dist/lang/index.js';
import { Lang } from '@debbie/common/dist/lang/Lang.js';
import { currentLang, setCurrentLang } from '../internal.js';
import * as actionTypes from './actionTypes.js';
registerLocale('da', da);
export const setLang = (lang) => {
    const l = lang ||
        (navigator.language &&
            Object.values(Lang).includes(navigator.language) &&
            navigator.language) ||
        Lang.en;
    const loc = l.slice(0, 2);
    if (loc === 'da') {
        setDefaultOptions({ locale: da });
    }
    else {
        setDefaultOptions({ locale: undefined });
    }
    moment.locale(loc);
    if (['da', 'en'].includes(loc)) {
        setDefaultLocale(loc);
    }
    else {
        setDefaultLocale('en');
    }
    const langSetting = {
        lang: langs.get(l),
        currentLang: l,
    };
    if (lang != null) {
        setCurrentLang(l);
    }
    return langSetting;
};
export const langReducer = (state = setLang(currentLang).lang, action) => {
    switch (action.type) {
        case actionTypes.SET_LANG:
            return setLang(action.payload.lang).lang;
        default:
            return state;
    }
};
export const currentLangReducer = (state = currentLang, action) => {
    switch (action.type) {
        case actionTypes.SET_LANG:
            return action.payload.lang;
        default:
            return state;
    }
};
//# sourceMappingURL=reducer.js.map